import {Form} from "react-bootstrap";
import React from "react";

const ParticipantForm = ({setNomeCognome, nomeCognome, setDataDiNascita, dataDiNascita, levels, setSelectedLevel}) =>{

        return (
            <>
                <Form.Group className="mb-3" controlId="nomecognome">
                    <Form.Label>Nome e cognome*</Form.Label>
                    <Form.Control type="text" value={nomeCognome} placeholder="Scrivi qui..." required onChange={(value) => setNomeCognome(value.target.value)}/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="datadinascita">
                    <Form.Label>Data di nascita*</Form.Label>
                    <Form.Control type="date" value={dataDiNascita} placeholder="Scrivi qui..." required onChange={(value) => setDataDiNascita(value.target.value)}/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="livelloraggiunto">
                    <Form.Label>Ultimo livello di nuoto raggiunto*</Form.Label>
                    <Form.Select aria-label="Default select example" required onChange={(event) => {setSelectedLevel(event.target.value)}} placeholder={"..."}>
                        <option value={""} disabled selected>Selezione livello</option>
                        {levels.map((currentLevel) => (<option key={currentLevel.id} value={currentLevel.level}>Livello {currentLevel.level}</option>))}
                    </Form.Select>
                </Form.Group>

                <p>*campi obbligatori</p>
            </>
        );
}
export default ParticipantForm;
